const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Play+Box+Details


function getPlayBoxDetails(profileId) {
    const url = `/api/users/profiles/${profileId}/playBoxes`;
    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => { 
        return data.errorCode ? Promise.reject(data) : data; 
    } );
}


module.exports = getPlayBoxDetails;
